PHI.breadcrumb = {

  init: function() {
    var $rootNavInBreadCrumb = $('#breadcrumb li:nth-child(2)');
    var navText = '';
    var $nav = '';

    if ($rootNavInBreadCrumb.length > 0) {
      navText = $.trim($rootNavInBreadCrumb.text());
      $nav = $('#top-navigation-wrapper > .navigation > li > a:contains(\'' + navText + '\')');

      if ($nav.length > 0) {
        $nav.parent().addClass('active');
      }
    }

    this.show();
  },

  show: function() {
    $('#breadcrumb').css({
      opacity: '1'
    });
  },

  hide: function() {
    $('#breadcrumb').css({
      opacity: '0'
    });
  }

};

$(function() {
  PHI.breadcrumb.init();
});
